angular.module('mtic.components.navbar', [])

angular.module('mtic.components.navbar')
.directive('navBar', function (userAccount, preliveCheck, api, LocaleService, PlatformService, $rootScope, $log) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope) {

      LocaleService.computeCurrentUrlVersion();

    	scope.isLoggedIn = function(){
    		return userAccount.isLoggedIn();
    	}
      scope.isTeacher = function()
      {
        return userAccount.getData().role.isTeacher;
      }


      scope.isLuxUser = function(){
        return LocaleService.getCurrentLocale() === 'LUXEMBOURG';
      }

      scope.isAdmin = function(){
        return userAccount.getData().isAdmin;
      }

      scope.mobileBurgerClick = function(){
        $rootScope.sidebarExpanded = !$rootScope.sidebarExpanded;
      }
      scope.isPreLive = preliveCheck.isPreliveCheck();

      scope.isOcmt = function(){
        return $rootScope.isOCMT;
      }
    }
  }
})
